<script lang="ts">
  let props = $props()
  let { answer } = props
</script>

<div
  class="lg:ml-8 mt-2 border-l-2 border-dashed border-blue-800 px-4 lg:px-6 py-3 lg:py-6 bg-sky-50 rounded-r"
>
  {#if answer == 1}
    <p class="text-base lg:text-xl/8 text-gray-700">
      A: <span class="font-bold"
        >“Good to see the team handled things without me.”</span
      >
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This shows your team is capable of making decisions without bottlenecking
      at you - a major marker of readiness.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Fast Attack crews train for the captain to be off deck - because readiness
      is a system, not a person.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Ask: <span class="italic">Could they sustain that for 30 days?</span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Document how they handled this situation - then use it to replicate
      decision ownership across other functions.
    </p>
  {:else if answer == 2}
    <p class="text-base lg:text-xl/8 text-gray-700">
      B: <span class="font-bold">“I hope they didn’t drop anything.”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This suggests <span class="font-bold"
        >partial decision-making autonomy</span
      >, but still signals some dependency or uncertainty.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      In elite teams, hoping the system holds isn’t enough. You need to know it
      will - because it’s been tested.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Run a “readiness drill.” Ask: <span class="italic"
        >If I was unavailable for a week, what decisions could the team make?</span
      >
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Then equip them with clear boundaries and protocols to make those
      confidently.
    </p>
  {:else if answer == 3}
    <p class="text-base lg:text-xl/8 text-gray-700">
      C: <span class="font-bold">“What went wrong while I was gone?”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This shows <span class="font-bold"
        >reactive leadership and a lack of decision confidence in your absence.
      </span>
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Fast Attack leaders don’t brace for failure when they leave - they build
      systems that succeed without them.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Debrief: <span class="italic"
        >Why didn’t we trust the team to lead in my absence?
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Then identify one area where you can install decision rules and hand over
      responsibility this quarter.
    </p>
  {:else if answer == 4}
    <p class="text-base lg:text-xl/8 text-gray-700">
      D: <span class="font-bold">“I knew I shouldn’t have left.”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is a signal that <span class="font-bold"
        >decision-making begins and ends with you - and the system can’t
        function independently.
      </span>
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      On a submarine, if everything relies on one leader, the mission is already
      compromised.
    </p>

    <p class="mt-6 text-sm lg:text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Pick one leader and transfer full ownership of a key area.
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Coach them through making real decisions - with your support, not your
      shadow.
    </p>
  {/if}
</div>
